import { render, staticRenderFns } from "./CalendarMonth.vue?vue&type=template&id=489c8e06"
import script from "./CalendarMonth.vue?vue&type=script&lang=ts"
export * from "./CalendarMonth.vue?vue&type=script&lang=ts"
import style0 from "./CalendarMonth.vue?vue&type=style&index=0&id=489c8e06&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports